import { ProductBasketDto } from "@api/*";

export interface ProductBasketStore extends ProductBasketDto {
  // Loading state
  loading: boolean;

  // Error state
  error: string | null;
}

export const initialProductBasketStore: ProductBasketStore = {
  loading: false,
  error: null,
  id: 0,
  basketProducts: [],
  isPunchOutBasket: false
};
